import { PayloadAction } from "@reduxjs/toolkit"
import { ObjectsStateT } from "../../objects.slice"
import { objectNodeUpdate } from "../object/objectNodeUpdate"
import { PayloadObjT } from "../object/objectTypes"

export const updateTickerObjectWithoutRestartBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<PayloadObjT>
) => {
    const id = action.payload.id
    state.value = {
        ...state.value,
        [id]: objectNodeUpdate(state.value[id], action.payload),
    }
    // DŮLEŽITÉ: NENASTAVUJEME updatedAt
    // To zajistí, že se ticker nebude restartovat při změnách jako fill (barva), atd.
}
